import { useTranslation } from "react-i18next";

const STATUS_KEYS = {
  "Verfügbar": "available",
  "Bestellbar": "orderable",
  "Bald verfügbar": "soon",
  "Auf Anfrage": "onRequest",
};

// Überlagert die deutschen API-Inhalte mit Übersetzungen (Kategorie, Tagline,
// Beschreibung, Features, Specs) und lokalisiert Status & Standardpreis-Text.
export function useLocalizeModel() {
  const { t, i18n } = useTranslation();
  return (m) => {
    if (!m) return m;
    const out = { ...m };
    if (i18n.language !== "de") {
      const mt = t(`models.${m.slug}`, { returnObjects: true, defaultValue: null });
      if (mt && typeof mt === "object") {
        out.category = mt.category || m.category;
        out.tagline = mt.tagline || m.tagline;
        out.description = mt.description || m.description;
        if (Array.isArray(mt.features)) out.features = mt.features;
        if (Array.isArray(mt.specs)) out.specs = mt.specs;
      }
    }
    const sk = STATUS_KEYS[m.status];
    out.status = sk ? t(`status.${sk}`) : m.status;
    out.price_text = m.price_text === "Preis auf Anfrage" ? t("priceOnRequest") : m.price_text;
    return out;
  };
}
